import { inject } from '@angular/core';
import { UserService } from '../providers/auth/user.service';
import { CanActivateFn, Router } from '@angular/router';
import { UserProfil } from '../providers/auth/user-profile.model';

export const accueilGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  let currentUser = userService.getCurrentUser();
  if (!currentUser) return false;

  const shouldDisplayAccueil = currentUser.is(UserProfil.Diffus) || currentUser.is(UserProfil.Mnt);
  const shouldDisplayCrt = currentUser.is(UserProfil.CRTLecture) || currentUser.is(UserProfil.CRTLectureEcriture);
  const shouldDisplayIOT = currentUser.is(UserProfil.IoT);
  const shouldDisplayTravaux = currentUser.is(UserProfil.Travaux);
  const shouldDisplayMagasinier = currentUser.is(UserProfil.Magasinier);

  if (shouldDisplayAccueil) {
    return true;
  } else if (shouldDisplayTravaux) {
    return router.parseUrl('/mnt/travaux');
  } else if (shouldDisplayMagasinier) {
    return router.parseUrl('/gestion-stocks');
  } else if (shouldDisplayCrt) {
    return router.parseUrl('/crt');
  } else if (shouldDisplayIOT) {
    return router.parseUrl('/iot');
  } else {
    return router.parseUrl('/shared/user');
  }
};
